import { Form } from 'factorial-form'

class Personal extends Form {
  constructor(values: object) {
    super(values, {
      locale: 'string',
      first_day_of_week: 'string',
      time_format: 'number',
    })
  }
}

export default Personal
